import PropTypes from 'prop-types';
import React from 'react';

import { Image as ImagePartial } from '$partials/media';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Image = ({
    caption = null,
    image   = null
}) => {
    // render
    return (
        <section className='module-image'>
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute top-0 md-relative md-col-2' />

                    {/* content */}
                    <div className='col-12 sm-col-12 md-col-10'>
                        <div className='ml9 sm-ml9 md-ml0'>
                            <div className='px-gutter'>
                                <figure>
                                    <div className='border-rad-10'>
                                        <ImagePartial {...image} />
                                    </div>

                                    {caption && (
                                        <figcaption className='type-style-5 mt3'>
                                            {caption}
                                        </figcaption>
                                    )}
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    caption: PropTypes.string,
    image: PropTypes.object.isRequired
};

Image.propTypes = propTypes;

export { Image };

export default Image;
